export default "__VITE_ASSET__DHMUzbwo__"